import { useTranslation } from "react-i18next";

import { IStaffTableData } from "../../../../../../@types/Staff";
import { Table } from "../../../../../../components/Table";
import { TableSkeleton } from "../../../../../../components/TableSkeleton";
import { AddStaffTitle, TableContainer } from "./ManageStaffTable.styles";
import { manageStaffTableColumns } from "./manageStaffTableColumns";

type ManageStaffTableProps = {
  content: IStaffTableData[];
  isLoading: boolean;
  handleAddStaff: () => void;
  handleOnRowClick: (rowContent: IStaffTableData) => void;
};

export function ManageStaffTable({
  content,
  isLoading,
  handleAddStaff,
  handleOnRowClick,
}: ManageStaffTableProps) {
  const { t } = useTranslation();

  if (isLoading) {
    return <TableSkeleton columnsNumber={7} rowsNumber={4} />;
  }

  return (
    <TableContainer>
      <AddStaffTitle onClick={handleAddStaff}>
        {t("settings_staff_addStaff")}
      </AddStaffTitle>
      <Table
        data={content}
        columns={manageStaffTableColumns}
        fontSize={14}
        onRowClick={handleOnRowClick}
        rowPadding
        rowPaddingRight="10px"
      />
    </TableContainer>
  );
}
